import type { FC } from 'react';
import { Inline } from '@george-labs.com/design-system';

import type { DateFormat } from '@luna/date';
import { formatDate } from '@luna/date';

import type { CommonItemProps } from './types';
import { ProductsListItemWrapper } from '../ProductsListItemWrapper';

type Props = CommonItemProps & {
    date: string;
    dateFormat?: DateFormat;
    bold?: boolean;
};

export const ProductsListDateItem: FC<Props> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    date,
    dateFormat,
    bold = false,
}) => {
    const displayedDate = dateFormat ? formatDate(date, dateFormat) : formatDate(date);

    return (
        <ProductsListItemWrapper
            data-cy={dataCy}
            className={className}
            label={label}
            labelClassName={labelClassName}
            labelColumnWidth={labelColumnWidth}
        >
            <Inline data-cy={dataCy} emphasis={bold}>
                {displayedDate}
            </Inline>
        </ProductsListItemWrapper>
    );
};
